function initializeSwipers() {
  // Initialize all Swiper instances
  if (typeof Swiper !== 'undefined') {
    // Technical details swiper
    if (document.querySelector('.section-technical-details__swiper-images')) {
      new Swiper(".section-technical-details__swiper-images", {
        loop: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
      });
    }

    // Technical details mobile swiper
    if (document.querySelector('.section-technical-details__info__mobile')) {
      new Swiper(".section-technical-details__info__mobile", {
        loop: false,
      });
    }

    // Review carousel swiper
    if (document.querySelector('#review-carousel')) {
      new Swiper("#review-carousel", {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        loop: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 200,
          modifier: 1,
          slideShadows: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }

    // Image carousel swiper
    if (document.querySelector('#image-carousel')) {
      new Swiper("#image-carousel", {
        slidesPerView: "auto",
        spaceBetween: 12,
        freeMode: true,
        loop: true,
        grabCursor: true,
        autoplay: {
          delay: 0,
        },
        speed: 5000,
      });
    }
  } else {
    // If Swiper is not loaded yet, try again in 100ms
    setTimeout(initializeSwipers, 100);
  }
}

// Wait for both DOM and Swiper to be loaded
document.addEventListener('DOMContentLoaded', function() {
  // Check if Swiper is already loaded
  if (typeof Swiper !== 'undefined') {
    initializeSwipers();
  } else {
    // If Swiper is not loaded yet, wait for it
    const checkSwiper = setInterval(function() {
      if (typeof Swiper !== 'undefined') {
        clearInterval(checkSwiper);
        initializeSwipers();
      }
    }, 100);
  }
}); 